import request from '@/utils/request'


// 查询数码圈分类列表
export function listDigitalType(query) {
  return request({
    url: '/digital/digital-type/list',
    method: 'get',
    params: query
  })
}

// 查询数码圈分类分页
export function pageDigitalType(query) {
  return request({
    url: '/digital/digital-type/page',
    method: 'get',
    params: query
  })
}

// 查询数码圈分类详细
export function getDigitalType(data) {
  return request({
    url: '/digital/digital-type/detail',
    method: 'get',
    params: data
  })
}

// 新增数码圈分类
export function addDigitalType(data) {
  return request({
    url: '/digital/digital-type/add',
    method: 'post',
    data: data
  })
}

// 修改数码圈分类
export function updateDigitalType(data) {
  return request({
    url: '/digital/digital-type/edit',
    method: 'post',
    data: data
  })
}

// 删除数码圈分类
export function delDigitalType(data) {
  return request({
    url: '/digital/digital-type/delete',
    method: 'post',
    data: data
  })
}
